export default {
  width: 30,
  height: 30,
  viewBox: '0 0 30 30',
  data: '<path d="M8 23.75L6.25 22L13.25 15L6.25 8L8 6.25L15 13.25L22 6.25L23.75 8L16.75 15L23.75 22L22 23.75L15 16.75L8 23.75Z" fill="white" stroke-width="0.5"/>',
};
